import { Link } from "react-router-dom";
import { resolveCategoryIcon } from "@/features/catalog/iconMap";
import type { Category } from "@/features/catalog/types";
import { cn } from "@/lib/utils";

type CategoryTileProps = {
    category: Category;
    className?: string;
    size?: "sm" | "md";
};

export function CategoryTile({
    category,
    className,
    size = "md",
}: CategoryTileProps) {
    const Icon = resolveCategoryIcon(category.icon);
    return (
        <Link
            to={`/categories/${category.slug}`}
            data-testid={`category-tile-${category.slug}`}
            className={cn(
                "group flex flex-col items-center rounded-2xl border border-border/60 bg-card p-3 text-center transition hover:-translate-y-0.5 hover:border-brand/40 hover:shadow-soft",
                className,
            )}
        >
            <span
                className={cn(
                    "mb-2 grid place-items-center rounded-2xl bg-gradient-to-br transition group-hover:scale-105",
                    category.gradient,
                    size === "sm" ? "h-12 w-12" : "h-16 w-16",
                )}
            >
                <Icon className={cn(size === "sm" ? "h-5 w-5" : "h-7 w-7", category.accent)} />
            </span>
            <span className="text-xs font-semibold text-foreground sm:text-sm">
                {category.name}
            </span>
            {size === "md" ? (
                <span className="mt-0.5 line-clamp-1 text-[10px] text-muted-foreground sm:text-xs">
                    {category.subtitle}
                </span>
            ) : null}
        </Link>
    );
}

export default CategoryTile;
